import { render, staticRenderFns } from "./luas_tanam_padi.vue?vue&type=template&id=0e279121&"
import script from "./luas_tanam_padi.vue?vue&type=script&lang=js&"
export * from "./luas_tanam_padi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports